import { render, staticRenderFns } from "./PropertiesSection.vue?vue&type=template&id=30351626&scoped=true"
import script from "./PropertiesSection.vue?vue&type=script&lang=js"
export * from "./PropertiesSection.vue?vue&type=script&lang=js"
import style0 from "./PropertiesSection.vue?vue&type=style&index=0&id=30351626&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30351626",
  null
  
)

export default component.exports